import { render, staticRenderFns } from "./SymphonyOperatingRooms.vue?vue&type=template&id=580fc997"
import script from "./SymphonyOperatingRooms.vue?vue&type=script&lang=ts"
export * from "./SymphonyOperatingRooms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports